import { render, staticRenderFns } from "./EmployeeBadges.vue?vue&type=template&id=5748723e&scoped=true"
import script from "./EmployeeBadges.vue?vue&type=script&lang=js"
export * from "./EmployeeBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5748723e",
  null
  
)

export default component.exports